import { usePostHttp } from "../../http.hook";

// biome-ignore lint/suspicious/noEmptyInterface: <explanation>
interface IResponse {}

export function useApproveInvoiceDetailsTransactionAdminHttp() {
	return usePostHttp<null, IResponse>({
		path: "/admin/payouts/transactions/:id/invoice-details/approve",
	});
}
